/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { cva } from 'class-variance-authority'
import type { FC, HTMLAttributes, PropsWithChildren } from 'react'
import React, { memo, useRef } from 'react'

const selectableCellCva = {
  root: cva(['box-border size-full'], {
    variants: {
      selected: {
        true: ''
      },
      groupSelected: {
        true: ''
      },
      copied: {
        true: '!outline-dashed outline-2 -outline-offset-2 !outline-brand-green-600',
        false: 'focus-visible:!outline-none'
      },
      focused: {
        true: ''
      },
      border: {
        x: '',
        y: '',
        all: ''
      }
    },
    compoundVariants: [
      {
        groupSelected: true,
        focused: true,
        class: ' bg-brand-green-100 hover:bg-brand-green-200/75'
      },
      {
        selected: true,
        focused: true,
        class:
          'bg-brand-green-200 shadow-border-1 shadow-brand-green-700 hover:bg-brand-green-300/50'
      },

      {
        border: 'x',
        selected: false,
        focused: true,
        groupSelected: true,
        class: 'shadow-border-x-1 shadow-brand-green-700'
      },
      {
        border: 'y',
        selected: false,
        focused: true,
        groupSelected: true,
        class: 'shadow-border-y-1 shadow-brand-green-700'
      }
    ]
  })
}

type Props = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    border?: 'x' | 'y'
    className?: string
    copied?: boolean
    selected?: boolean
    groupSelected?: boolean
    focused?: boolean
  }>

export const BaseTarget: FC<Props> = memo(
  ({
    border,
    className,
    children,
    onClick,
    selected,
    copied,
    focused,
    groupSelected,
    ...other
  }) => {
    const myRef = useRef<HTMLDivElement>(null)

    return (
      <div
        tabIndex={0}
        ref={myRef}
        className={selectableCellCva.root({
          className,
          border,
          selected,
          groupSelected,
          copied,
          focused
        })}
        onClick={e => {
          e.stopPropagation()
          if (onClick) {
            onClick(e)
          }
        }}
        {...other}
      >
        {children}
      </div>
    )
  }
)
